import { Divider, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import AppTable from "../../../../shared/AppTable";

const SupportingInfoTable = ({ data, loading }) => {
  const { t } = useTranslation();

  function downloadBase64File(base64Data, fileName, fileType) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
  }

  const columns = [
    {
      header: t("Sequence"),
      render: (row, index) => index + 1,
    },
    {
      header: t("Category"),
      render: (row) => row?.category || t("N/A"),
    },
    {
      header: t("Code"),
      render: (row) => (
        <span className="font-semibold text-[#0070C2] text-xs">
          {row?.code || t("N/A")}
        </span>
      ),
    },
    {
      header: t("Timing"),
      render: (row) =>
        `${row.start_date || ""}${
          row.end_date ? ` - ${row.end_date}` : ""
        }`.trim() || t("N/A"),
    },
    {
      header: t("Value"),
      render: (row) => {
        if (row?.category === "attachment") {
          return (
            <button
              style={{ backgroundColor: "#0070C2" }}
              className="px-2 py-0.5 rounded text-[0.65rem] text-white"
              onClick={() => {
                if (row?.image_url && row?.image_url !== "") {
                  const a = document.createElement("a");
                  a.href = row.image_url;
                  a.download = row?.image_title || "download";
                  a.target = "_blank";
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                } else if (row?.image_value) {
                  downloadBase64File(
                    row?.image_value,
                    row?.image_title,
                    row?.image_content_type,
                  );
                }
              }}
            >
              {row?.image_title}
            </button>
          );
        }
        return (
          <span className="whitespace-pre-wrap text-xs">
            {row?.value || t("N/A")}
          </span>
        );
      },
    },
    {
      header: t("Reason"),
      render: (row) => row?.reason || t("N/A"),
    },
  ];

  return (
    <AppTable
      columns={columns}
      data={data?.data?.supporting_info || []}
      loading={loading}
      actions={false}
    />
  );
};

export default SupportingInfoTable;
